import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'

import { getTokens } from 'core/classes/helpers/StorageHelper'
import { proxy } from 'core/classes/helpers/UrlHelper'
import { HttpHeaders, Rest } from 'core/classes/http'
import Logger from 'core/utils/Logger'

export interface ICopyFromPreviousYear {
  ownerId: string
  partnerId: string
  programType: ProgramTypes
  fYear: number
}

export const copyFromPreviousYear = async ({
  ownerId,
  partnerId,
  programType,
  fYear,
}: ICopyFromPreviousYear) => {
  const url = proxy('/webservice/621/sp/v3/spJBPKeyInitiativesCopyFromPrevYear/call')
  const [accessToken] = getTokens(ownerId)
  const headers = new HttpHeaders()
  if (accessToken) {
    headers.add('Authorization', `Bearer ${accessToken}`)
  }
  const payload = {
    'p.PartnerId': partnerId,
    'p.FYear': fYear,
    'p.ProgramType': programType,
  }

  try {
    await Rest.post({ url, payload, headers })
  } catch (e: any) {
    Logger.error('Error on copy from previous year: ', e)
  }
}
